/* eslint-disable arrow-body-style */
import React from 'react';
import { Redirect } from 'react-router-dom';

// route paths
import * as ROUTE_PATHS from 'constants/route-paths';

// hight-order-components
import { routeChangeListener } from 'ui/hoc/routeChangeListener';
import { checkAppContext } from 'ui/hoc/checkAppContext';
import { checkIfLoggedIn } from 'ui/hoc/checkIfLoggedIn';
import { withExitWarning } from 'ui/hoc/withExitWarning';

// route components
import { Dashboard } from 'ui/containers/Dashboard';
import { Reports } from 'ui/containers/Reports';
import { Administration } from 'ui/containers/Administration';
import { notFound as NotFound } from 'ui/views/layouts/notFound';
import { unauthenticated as Unauthenticated } from 'ui/views/layouts/unauthenticated';
import { samlError as SamlError } from 'ui/views/layouts/samlError';
import { AccessManagement } from 'ui/containers/AccessManagement';
import { SsoLogoutContainer } from 'ui/containers/SsoLogoutContainer';


// demo routes
import { demo as DemoView } from 'ui/views/demo/demo';
import { form as FormDemoView } from 'ui/views/demo/form';
import { CagFilterDemo } from 'ui/views/demo/cagFilter';
import { charts as ChartsView } from 'ui/views/demo/charts';

/*****************************************************/


// route configuration and sub-routes
export const routes = {

    // default home page (only redirects)
    HOME: {
        path: ROUTE_PATHS.HOME,
        exact: true,
        render( props ) {
			return <Redirect to={ { pathname: ROUTE_PATHS.DASHBOARD, state: { previousURL: props.location.pathname } } } />;
		},
    },

    SSO_LOGOUT: {
		path: ROUTE_PATHS.SSO_LOGOUT,
		exact: true,
        component: checkIfLoggedIn( checkAppContext( routeChangeListener( withExitWarning( SsoLogoutContainer ) ) ) ),
    },


    // MSR default landing page (dashboard)
    DASHBOARD: {
        path: `${ ROUTE_PATHS.DASHBOARD }/:widget?`,
        exact: true,
        component: checkIfLoggedIn( checkAppContext( routeChangeListener( withExitWarning( Dashboard ) ) ) ),
    },

    // MSR reports landing page
    REPORTS: {
        path: `${ ROUTE_PATHS.REPORTS }/:widget?`,
        exact: true,
        component: checkIfLoggedIn( checkAppContext( routeChangeListener( withExitWarning( Reports ) ) ) ),
    },

    // MSR administration landing page
    ADMINISTRATION: {
        path: `${ ROUTE_PATHS.ADMINISTRATION }/:widget?`,
        exact: true,
        component: checkIfLoggedIn( checkAppContext( routeChangeListener( withExitWarning( Administration ) ) ) ),
    },

    // MSR access management landing page
    ACCESS_MANAGEMENT: {
        path: `${ ROUTE_PATHS.ACCESS_MANAGEMENT }/:widget?`,
        exact: true,
        component: checkIfLoggedIn( checkAppContext( routeChangeListener( withExitWarning( AccessManagement ) ) ) ),
    },
    
    /*--------------*/

    // general use-case demo route
    DEMO_DEMO: {
        path: '/demo',
        exact: true,
        component: DemoView,
    },
    
    // general use-case demo route recharts
    DEMO_CHART: {
        path: '/demo-charts',
        exact: true,
        component: ChartsView,
    },

    // form demo using `react-hooks-form`
    DEMO_FORM: {
        path: '/demo-form',
        exact: true,
        component: FormDemoView,
    },

    // cag filter demo
    DEMO_CAG: {
        path: '/demo-cag',
        exact: true,
        component: checkAppContext( CagFilterDemo ),
    },

    /*--------------*/

    // 404 not found page
    NOT_FOUND: {
        path: ROUTE_PATHS.NOT_FOUND,
        exact: false,
        component: NotFound,
    },

    // when the user is unauthenticated
    UNAUTHENTICATED: {
		path: ROUTE_PATHS.UNAUTHENTICATED,
		exact: true,
		component: Unauthenticated,
    },
    
    // when SSO error occurs
    SAML_ERROR: {
		path: ROUTE_PATHS.SAML_ERROR,
		exact: true,
		component: SamlError,
	},

    // matches all paths only if none of the above matches
    // it redirects to `NOT_FOUND` route
    REDIRECT: {
        path: ROUTE_PATHS.REDIRECT,
        exact: false,
        render( props ) {
            return <Redirect to={ { pathname: ROUTE_PATHS.NOT_FOUND, state: { previousURL: props.location.pathname } } } />;
        },
    }
};
